import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const Step5Images = ({
    values,
    setFieldValue,
    submitted,
    roomImages,
    selectedRoom,
    handleRoomClick,
    handleRoomImageChange,
    handleRemoveRoomImage,
    imagePreviews,
    handleImageChange,
    apicalled,
    SelectedImagesError,
    selectedImages,
    setSelectedImages,
    setImagePreviews,
    roomErrors,
    t,
}) => {
    return (
        <>
            {values?.room_type == "multi" ? (
                values?.rooms &&
                (Array.isArray(values.rooms)
                    ? values.rooms
                    : JSON.parse(values.rooms)
                ).map((room, roomIndex) => (
                    <React.Fragment key={roomIndex}>
                        <div className="roomContainer my-4 mx-2">
                            <div className="roomFlex">
                                <Link
                                    to="#"
                                    className={selectedRoom === roomIndex ? "active" : ""}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleRoomClick(roomIndex);
                                    }}
                                >
                                    {t("AddProperties.roomnumber", {
                                        roomNumber: roomIndex + 1,
                                    })}
                                </Link>
                            </div>
                        </div>
                        {/* MARK: RENDER MULTIPLE IMAGES */}
                        {selectedRoom === roomIndex && (
                            <div className="stepImageUpload">
                                <Row className="w-100">
                                    {roomImages[roomIndex]?.imagePreviews?.map(
                                        (image, imageIndex) => (
                                            <Col
                                                md={3}
                                                width="25%"
                                                className="py-2"
                                                key={imageIndex}
                                            >
                                                <div
                                                    className="imageBg"
                                                    style={{
                                                        backgroundImage: `url(${image})`,
                                                    }}
                                                >
                                                    {!apicalled && (
                                                        <Icon
                                                            icon="carbon:close-filled"
                                                            fontSize={30}
                                                            className="cross"
                                                            color="#000000"
                                                            onClick={() =>
                                                                handleRemoveRoomImage(
                                                                    roomIndex,
                                                                    imageIndex,
                                                                    setFieldValue
                                                                )
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            </Col>
                                        )
                                    )}
                                    <Col lg={3} sm={3} md={3} className="py-2">
                                        <div className="imageBg d-flex justify-content-center align-items-center">
                                            <input
                                                type="file"
                                                accept=".png, .jpg, .jpeg"
                                                multiple
                                                onChange={(e) =>
                                                    handleRoomImageChange(e, setFieldValue, roomIndex)
                                                }
                                                style={{ display: "none" }}
                                                id={`imageUpload-${roomIndex}`}
                                            />
                                            <label
                                                htmlFor={`imageUpload-${roomIndex}`}
                                                className="text-center"
                                            >
                                                <Icon
                                                    icon="ic:baseline-plus"
                                                    fontSize={50}
                                                    color="#1B91BF"
                                                    className="text-center"
                                                />
                                                <h2 style={{ fontSize: 17 }}>
                                                    {t("AddProperties.addImage")}
                                                </h2>
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}
                        {roomErrors[`room${roomIndex + 1}`] && (
                            <div className="text-start mt-3 errorStyle">
                                {roomErrors[`room${roomIndex + 1}`]}
                            </div>
                        )}
                    </React.Fragment>
                ))
            ) : (
                <React.Fragment>
                    <div className="roomFlex my-4">
                        <Link to="#" className="active" onClick={(e) => e.preventDefault()}>
                            {t("AddProperties.room", { roomNumber: 1 })}
                        </Link>
                    </div>
                    <div className="stepImageUpload ">
                        <Row className="w-100">
                            {imagePreviews &&
                                imagePreviews?.length > 0 &&
                                imagePreviews.map((image, index) => (
                                    <Col key={index} md={3} width="25%" className="py-2">
                                        <div
                                            className="imageBg"
                                            style={{
                                                backgroundImage: `url(${image})`,
                                            }}
                                        >
                                            {!apicalled && (
                                                <Icon
                                                    icon="carbon:close-filled"
                                                    fontSize={30}
                                                    className="cross"
                                                    color="#000000"
                                                    onClick={() => {
                                                        const newImagePreviews = imagePreviews.filter(
                                                            (_, i) => i !== index
                                                        );
                                                        const newSelectedImages = selectedImages.filter(
                                                            (_, i) => i !== index
                                                        );

                                                        setImagePreviews(newImagePreviews);
                                                        setSelectedImages(newSelectedImages);
                                                        setFieldValue("images", newSelectedImages);
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </Col>
                                ))}
                            <Col md={3} className="py-2">
                                <div className="imageBg imageBg1">
                                    <input
                                        type="file"
                                        accept=".png, .jpg, .jpeg"
                                        multiple
                                        onChange={(e) => handleImageChange(e, setFieldValue)}
                                        style={{ display: "none" }}
                                        id="imageUpload"
                                    />
                                    <label htmlFor="imageUpload" className="text-center">
                                        <Icon
                                            icon="ic:baseline-plus"
                                            fontSize={50}
                                            color="#1B91BF"
                                            className="text-center"
                                        />
                                        <h2>{t("AddProperties.addImage")}</h2>
                                    </label>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    {SelectedImagesError && (
                        <div className="text-start mt-3 errorStyle">
                            {t("AddProperties.selectAtLeastOneImage")}
                        </div>
                    )}
                </React.Fragment>
            )}
        </>
    );
};

export default Step5Images;
